import React from "react";
import { Navigate } from "react-router-dom";

export default function PartnerProtectedRoute({ children }) {
  const token = localStorage.getItem("partner_token");
  if (!token) {
    return <Navigate to="/partner/login" replace />;
  }
  return children;
}
